
import React, {Component} from 'react';
import './App.css';

import Image from './WishHandle';
import MakeWish from './resetStates';
import WishNav from './wishNav';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { faPause } from '@fortawesome/free-solid-svg-icons';

//import Images
import travelerIMG from './traveler.webp';
import drifterIMG from './img/modal-media/D2-Drifter.jpg';
import failsafeIMG from './img/modal-media/Failsafe.webp';

import itemFrame from './img/modal-media/itemframe_ani.png';
import etherialKey from './img/modal-media/etherialKey-wish1.jpg';
import chestAni from './img/modal-media/chest_spritesheet.png';
import Ship from './img/modal-media/ship.jpg';
import AhamkaraEgg from './img/modal-media/Ahamkara_Egg.png';
import Darkness from './img/modal-media/darknessZone.png';
import DarknessGhost from './img/modal-media/darknessGhost_spritesheet.png';
import Throne from './img/modal-media/throne_room.jpg';

//cell images
import cellEmpty from './img/cell_Img/00-Empty.png';
import cellFish1 from './img/cell_Img/AA-Fish_normal.png';
import cellFish2 from './img/cell_Img/AB-Fish_circle.png';
import cellFish3 from './img/cell_Img/AC-Fish_yingyang.png';
import cellFish4 from './img/cell_Img/AD-Fish_jumpup.png';
import cellSnake1 from './img/cell_Img/BA-Snake_infinite.png';
import cellSnake2 from './img/cell_Img/BB-Snake_eight.png';
import cellSnake3 from './img/cell_Img/BC-Snake_Sform.png';
import cellSnake4 from './img/cell_Img/BD-Snake_mustache.png';
import cellDragon1 from './img/cell_Img/CA-Dragon_fireleft.png';
import cellDragon2 from './img/cell_Img/CB-Dragon_fireright.png';
import cellDragon3 from './img/cell_Img/CC-Dragon_spearneck.png';
import cellDragon4 from './img/cell_Img/CD-Dragon_spearclaws.png';
import cellBird1 from './img/cell_Img/DA-Bird_falling.png';
import cellBird2 from './img/cell_Img/DB-Bird_tree.png';
import cellBird3 from './img/cell_Img/DC-Bird_fly.png';
import cellBird4 from './img/cell_Img/DD-Bird_walk.png';

//import media (sfx & videos)
import failsafeSFX from './img/modal-media/Failsafe.ogg';
import drifterSFX from './img/modal-media/Drifter.ogg';
import hopeSFX from './img/modal-media/HopeForTheFuture.ogg';

import itemSFX from './img/modal-media/legendaryengram.ogg';
import chestSFX from './img/modal-media/chest_sfx.ogg';
import petraSFX from './img/modal-media/petra.ogg';

import ShuroChi from "./img/modal-media/ShuroChi_720p.mp4";
import Morgeth from "./img/modal-media/Morgeth_720p.mp4";
import Vault from "./img/modal-media/Vault_720p.mp4";
import Riven from "./img/modal-media/Riven_720p.mp4";

import auto from './img/modal-media/wish14loot/auto.jpg';





/* Play button, toggle between play & pause */
const Play = ({ play, onClick}) => {
  return(
    <div>
    <audio id="audioFailsafe" preload="none">
      <source src={failsafeSFX} type="audio/ogg" />
      </audio>
      <FontAwesomeIcon icon={play ? faPause : faPlay} fixedWidth className="fontIcon play" onClick={onClick}/>
    </div>
    
  )
}

/* Play button, toggle between play & pause, Play button for Wish 8 */
const PlayHope = ({ play, onClick}) => {
  return(
    <div>
    <audio id="audioHope" preload="none">
      <source src={hopeSFX} type="audio/ogg" />
      </audio>
      <FontAwesomeIcon icon={play ? faPause : faPlay} fixedWidth className="playHope" onClick={onClick}/>
      <img src={travelerIMG} alt="traveler" className="traveler"/>
    </div>
  )
}

/* Play button, toggle between play & pause, Play button for Wish 8 */
const PlayDrifter = ({ play, onClick}) => {
  return(
    <div>
    <audio id="audioDrifter" preload="none">
      <source src={drifterSFX} type="audio/ogg" />
      </audio>
      <FontAwesomeIcon icon={play ? faPause : faPlay} fixedWidth className="fontIcon playDrifter" onClick={onClick}/>
    </div>
  )
}



                                        /* //////////////////////////
                                                RENDER SITE 
                                        //////////////////////////*/
class App extends Component{

  constructor(){
    super()
    this.state={

      imgs: [cellEmpty,cellFish1,cellFish2,cellFish3,cellFish4,cellSnake1,cellSnake2,cellSnake3,cellSnake4,
              cellDragon1,cellDragon2,cellDragon3,cellDragon4,cellBird1,cellBird2,cellBird3,cellBird4],
        count: 0,
        pointer: 0,

        play: false
    }; 
     }   

     /* toggles play buttons (play & pause) */
     handlePlay = () =>{

       this.setState({play: !this.state.play});
     } 

render() {

  const {imgs}=this.state;

      return (
        <div className="App">
          <header className="appHeader" id="headerRiven">Wall of Wishes</header>
          <div className="content">

          <div className="wall-container">

            {/* First Row */}
      
              <Image imgs={imgs.slice(0,17)}/>        
               
              <Image imgs={imgs.slice(0,17)}/>   
   
              <Image imgs={imgs.slice(0,17)}/>   
   
              <Image imgs={imgs.slice(0,17)}/>   

              <Image imgs={imgs.slice(0,17)}/>   
            
        

          {/* Second Row */}
              <Image imgs={imgs.slice(0,17)}/>        
               
              <Image imgs={imgs.slice(0,17)}/>   
    
              <Image imgs={imgs.slice(0,17)}/>   
    
              <Image imgs={imgs.slice(0,17)}/>   
 
              <Image imgs={imgs.slice(0,17)}/>  

          {/* Third Row */}
              <Image imgs={imgs.slice(0,17)}/>        
               
              <Image imgs={imgs.slice(0,17)}/>   
    
              <Image imgs={imgs.slice(0,17)}/>   
    
              <Image imgs={imgs.slice(0,17)}/>   
 
              <Image imgs={imgs.slice(0,17)}/>  

          {/* Fourth Row */}
              <Image imgs={imgs.slice(0,17)}/>        
               
              <Image imgs={imgs.slice(0,17)}/>   
    
              <Image imgs={imgs.slice(0,17)}/>   
    
              <Image imgs={imgs.slice(0,17)}/>   
 
              <Image imgs={imgs.slice(0,17)}/>  
          
             

            </div>

          {/* Wish Wall make a Wish Button, button to grant you the wishes */}
          <MakeWish/>

    
          </div>

          {/* Wish Nav */}
          <WishNav/>
         

           {/* Modals */}

           {/* WISH 1 MODAL - Etherical Key */}
           <div id="wish1-modal" className="modal">
             <span className="close1">&times;</span>            
             <div id="wrapper_border">
             <img src={etherialKey} alt="Etherial Key" className="etherialkey"/>
             <img src={itemFrame} alt="animated background" className="item" id="drop"/>
             <audio className="itemSfx"><source src={itemSFX}/></audio>
             </div>             
           </div>

           {/* WISH 2 MODAL - Ship Chest*/}
           <div id="wish2-modal" className="modal">
             <span className="close2">&times;</span>
             <div className="chestWrapper">
             <img src={chestAni} alt="Last Wish Chest" className="chest"/>
             </div>

             <div className="shipWrapper dropShip">
                <img src={Ship} alt="last wish ship" className="ship"/>
                <img src={itemFrame} alt="loot background" className="shipLoot"/>
                <audio className="shipSfx"><source src={itemSFX}/></audio>
                <audio className="chestSfx"><source src={chestSFX}/></audio>
             </div>
            
           </div>

          {/* WISH 3 MODAL - Number of Power Emblem */}
          {/* is in header */}
          {/* <div id="wish3-modal" className="modal">
             <span className="close3">&times;</span>
             <img src="..\img\modal-media\emblem_wish3.jpg" alt="Number of Power Emblem" className="emblem"/>
           </div> */}

          {/* WISH 4 MODAL - Shuro Chi */}
          <div id="wish4-modal" className="modal">
             <span className="close4">&times;</span>
             <video src={ShuroChi} className="shuroChi"></video>
           </div>

          {/* WISH 5 MODAL - Morgeth */}
          <div id="wish5-modal" className="modal">
             <span className="close5">&times;</span>
             <video src={Morgeth} className="morgeth"></video>
           </div>

          {/* WISH 6 MODAL - Vault */}
          <div id="wish6-modal" className="modal">
             <span className="close6">&times;</span>
             <video src={Vault} className="vault"></video>
           </div>

           {/* WISH 7 MODAL - Riven */}
           <div id="wish7-modal" className="modal">
             <span className="close7">&times;</span>
             <video src={Riven} className="riven"></video>
           </div>

          {/* WISH 8 MODAL - Hope for the Future */}
          <div id="wish8-modal" className="modal">
             <span className="close8">&times;</span>
             <PlayHope play={this.state.play} onClick={this.handlePlay}  className="hopePlay"/>   
           </div>

           {/* WISH 9 MODAL - Failsafe */}
           <div id="wish9-modal" className="modal">
             <span className="close9">&times;</span>
            <img src={failsafeIMG} alt="Failsafe" className="modalMedia"/>
            <Play play={this.state.play} onClick={this.handlePlay} />         
           </div>

           {/* WISH 10 MODAL - Drifter */}
           <div id="wish10-modal" className="modal">
             <span className="close10">&times;</span>
            <img src={drifterIMG} alt="Drifter" className="modalMedia"/>
            <PlayDrifter play={this.state.play} onClick={this.handlePlay} />           
           </div>

           {/* WISH 11 MODAL - Brithday Party Effect (Firework Particle) */}
           <div id="wish11-modal" className="modal11">
             <span className="close11">&times;</span>
            <div className="confetti">
              <button className="wish11Btn" id="circle"></button>
              </div>         
           </div>

          {/* WISH 12 MODAL - Fireteam Effect (random Particle effect) */}
          <div id="wish12-modal" className="modal">
             <span className="close12">&times;</span>
             <canvas id="rainbownet" className="hide"></canvas>
             <div className="rain hide"></div>
             <div className="littleLight hide"></div>                         
           </div>

          {/* WISH 13 MODAL - Petra's Run (Darkness Zone) */}
          <div id="wish13-modal" className="modal">
             <span className="close13">&times;</span>
            <img src={Darkness} alt="Darkness Zone" className="darkness"/>
            <div className="ghost_wrapper">
            <img src={DarknessGhost} alt="animated ui" className="ghostDarkness"/>
            <span className="caption">Respawning Restricted</span>
            </div>
            <audio className="petraAudio">
              <source src={petraSFX}/>
            </audio>
           </div>

           {/* WISH 14 MODAL - Ahamkara Eggs */}
          <div id="wish14-modal" className="modal">
             <span className="close14">&times;</span>
             <img src={AhamkaraEgg} alt="Ahamkara Egg" className="egg"/>
             <img src={AhamkaraEgg} alt="Ahamkara Egg" className="egg"/>
             <img src={AhamkaraEgg} alt="Ahamkara Egg" className="egg"/>
             <img src={AhamkaraEgg} alt="Ahamkara Egg" className="egg"/>
             <img src={AhamkaraEgg} alt="Ahamkara Egg" className="egg"/>

             <div className="loot_wrapper" id="eggLoot">
             <img src={auto} alt="dreaming city loot" className="loot"/>
             <img src={itemFrame} alt="animated background" className="lootitem"/>
             <audio className="itemSfx14"><source src={itemSFX}/></audio>
             </div>
           </div>

           {/* WISH 15 MODAL - The Helmet stayed on ( ͡° ͜ʖ ͡°) */}
          <div id="wish15-modal" className="modal">
             <span className="close15">&times;</span>
             <div className="lore">
               <h3>I wish to be feared.</h3>
               <p>
              "Mara stared at the Wall of Wishes. She had no more bargains to make. Her plans were in motion.
              There was nothing left but the wait.
              </p>
             <p>
              She pulled a sidearm from a hidden holster and cracked a dozen rounds into the Wall.
              The cosmic balance shifted. Somewhere in the Dreaming City, Riven heard the Queen's wish and a thousand shrieking tears in reality cut through the space in front of her.
              </p>
              <p>
              Lord Shaxx suddenly blocked Mara's view of the Wall.
              "—YES, AND WE'D ALL BE DEAD!" He was screaming at no one, with a mug of caffeine in his fist.
           
              He started, almost spilling his coffee. "Where are we?"
              </p>
              <p>
              Mara slapped the mug out of his hand. It shattered on the floor. She shoved a weathered book in his face.
              "I told you there would come a time when I collect for the Reef Wars. Read this. Out loud."
              "No one tells me what to do," he said, grabbing the book and incinerating it in a bolt of Striker lightning. "I can recite The Tempest by heart."
              And he did. Mara sat and listened. They stayed for a long time.
              </p>
             <p>
              The helmet stayed on. "
               </p>
             </div>
             <img src={Throne} alt="throne room" className="throne"/>
           </div>
               
        </div>
      );
    }

}


  

export default App;
